import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DirectRoutingModule } from "./direct-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DirectComponent } from "./page/direct/direct.component";
import { ScraiiAiComponent } from "./page/scraii-ai/scraii-ai.component";
import { ScraiiControlChartComponent } from "./page/scraii-ai/control-chart/scraii-control-chart.component";
import { ScraiiGanttChartComponent } from "./page/scraii-ai/gantt-chart/scraii-gantt-chart.component";
import { MatComponentsModule } from "src/app/mat-components.module";
import { AgGridModule } from "ag-grid-angular";
import { DashboardModule } from "../dashboard/dashbaord.module";
import { DynamicEmailTableComponent } from "./components/dynamic-email-table/dynamic-email-table.component";
import { EmailTemplateDesignerComponent } from "./page/email-template-designer/email-template-designer.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkMenuModule } from "@angular/cdk/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { EmailExtractsComponent } from "./page/email-extracts/email-extracts.component";
import { ChartsModule } from "src/app/components/shared/charts/charts.module";
import { WidgetModule } from "../widget/widget.module";
import { TaskDetailPageComponent } from "./page/task-detail/task-detail.component";
import { MarkdownRenderPipe } from "src/app/pipe/markdown-render.pipe";
import { TaskPanelModule } from "./task-panel.module";
import { ColumnDisplayNamePipe } from "src/app/pipe/column-display-name.pipe";
import { S09WorkflowShellComponent } from "./page/s09-workflow/s09-workflow-shell.component";
import { S09WorkflowListComponent } from "./page/s09-workflow/s09-workflow-list.component";
import { S09WorkflowDesignerComponent } from "./page/s09-workflow/s09-workflow-designer.component";
import { S09CreateDialogComponent } from "./page/s09-workflow/s09-create-dialog.component";
import { S09TemplatesComponent } from "./page/s09-workflow/s09-templates.component";
import { S09DataSignalsComponent } from "./page/s09-workflow/s09-data-signals.component";
import { S09EntrySignalsComponent } from "./page/s09-workflow/s09-entry-signals.component";
import { S09CaseFlowComponent } from "./page/s09-workflow/s09-case-flow.component";
import { S09WorkflowRunComponent } from "./page/s09-workflow/s09-workflow-run.component";

@NgModule({
  declarations: [
    DirectComponent,
    ScraiiAiComponent,
    ScraiiControlChartComponent,
    ScraiiGanttChartComponent,
    S09WorkflowShellComponent,
    S09WorkflowListComponent,
    S09WorkflowDesignerComponent,
    S09CreateDialogComponent,
    S09TemplatesComponent,
    S09DataSignalsComponent,
    S09EntrySignalsComponent,
    S09CaseFlowComponent,
    S09WorkflowRunComponent,
    DynamicEmailTableComponent,
    EmailTemplateDesignerComponent,
    EmailExtractsComponent,
    TaskDetailPageComponent,
    MarkdownRenderPipe,
    ColumnDisplayNamePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectRoutingModule,
    DashboardModule,
    AgGridModule,
    MatComponentsModule,
    DragDropModule,
    CdkMenuModule,
    NgSelectModule,
    ChartsModule,
    WidgetModule,
    TaskPanelModule,
  ],
  exports: [DirectComponent, ScraiiAiComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DirectModule {}
